import React, { useEffect, useState } from "react";
import {
  useNavigate,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import GlobalLoader from "../../common/GlobalLoader";
import EmptyPage from "../../common/emptyPage";
import Cookies from "js-cookie";
import "../../../styles/teacher/homeworkBatches.scss";
import { getAllBatchInstitution } from "../../../helper/apicalls/institution/institutionBatch";
import TeacherBatchCard from "./TeacherBatchCard";

const HomeworkBatches = () => {
  const authToken = Cookies.get("institution_token");
  const role = Cookies.get("role");
  const navigate = useNavigate();
  const { setHeaderName, setIsShowSearch } = useOutletContext();
  const [searchParams] = useSearchParams();
  const courseKey = searchParams.get("course");

  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchBatches = async () => {
    if (!courseKey) return;
    setLoading(true);
    try {
      const res = await getAllBatchInstitution(authToken, courseKey, {});
      setBatches(res?.data || []);
    } catch (e) {
      console.error("Failed to fetch homework batches:", e);
      setBatches([]);
    } finally {
      setLoading(false);
    }
  };

  const handleBatchClick = (batch) => {
    if (!courseKey) return;
    const bid = batch?._id || batch?.id || batch?.batch_id || "";
    const qp = bid ? `?batch=${encodeURIComponent(bid)}` : "";
    navigate(`/teacher/homework/course/${courseKey}${qp}`);
  };

  useEffect(() => {
    setHeaderName && setHeaderName("Homework");
    setIsShowSearch && setIsShowSearch(false);
  }, [setHeaderName, setIsShowSearch]);

  useEffect(() => {
    fetchBatches();
  }, [courseKey]);

  return (
    <div className="homework-batches-container">
      <GlobalLoader visible={loading} text="Loading batches..." />
      <div className="homework-batches-header">
        <h2 style={{ margin: 0 }}>Batches List</h2>
      </div>
      {Array.isArray(batches) && batches.length > 0 ? (
        <div className="homework-batches-grid">
          {batches.map((data, index) => (
            <TeacherBatchCard
              key={index}
              batch={data}
              onClick={() => handleBatchClick(data)}
            />
          ))}
        </div>
      ) : (
        <EmptyPage content={"No batches Available"} />
      )}
    </div>
  );
};

export default HomeworkBatches;
